import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  flex: 1;
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const InteractionsContainer = styled.div``;
